import { Card, Tabs, Badge } from "antd"

import { ReportsByLocation } from "./locationtab/ReportsByLocation";
import { LockFilled, SettingOutlined, UnlockFilled } from "@ant-design/icons";
import { useState } from "react";
import { ButtonLZ } from "../../../components/design/Buttons/ButtonLZ";
import { ReportDefinitionsDrawer } from "./drawers/ReportDefinitionsDrawer";
import { ReportsByProject } from "./locationtab/ReportsByProject";
import { useModuleActive } from "../../common/roles/Roles";
import { ModuleAccessGate } from "../../common/roles/ModuleAccessGate";
import { PageTitle } from "../../common/PageTitle";

export const Reports = () => {
	
	const [scheduledReportsDrawer, setScheduledReportsDrawer] = useState(false);
	const [refreshDefinitions, setRefreshDefinitions] = useState(false);
	const isModuleActive = useModuleActive();

    return (
		<>
			<Card className='main-card-content'>            
				
				<PageTitle
					title='Informes'
					pageInfo='Configura el envío automático de informes por email a nivel de proyecto o separado por cada uno de los locales si quieres involucrar a los responsables de cada local. Cada uno de estos informes buscan medir el rendimiento de los KPIs principales de cada uno de los módulos, no es por tanto un sistema de alertas ni una auditoría de seo local con consejos, es la monitorización del rendimiento de cada uno de los aspectos de tu presencia local.'
					extra={
						<ButtonLZ onClick={() => setScheduledReportsDrawer(true)} type='ghost'>
							<SettingOutlined/> Mis Informes
						</ButtonLZ>
					}
				/>
				<br/>

				<Tabs defaultActiveKey="1" type="line">    
					<Tabs.TabPane
						tab={<span className='title-tabPane'>Proyecto</span>}
						key="1">                
						<ReportsByProject refreshDefinitions={refreshDefinitions}/>         
					</Tabs.TabPane> 

					<Tabs.TabPane
                        tab={
                            <Badge 
                                offset={[25, 0]} 
                                count={isModuleActive('NETWORK') ? <UnlockFilled style={{ color: 'green' }} /> : <LockFilled style={{ color: 'crimson' }} />}
                            >
                                <span className='title-tabPane'>Local</span>
                            </Badge>
                        }
                        key="2"
                    >        
						<ModuleAccessGate
							module='NETWORK'
							title='Informes por local'
							message='No tienes permiso para los informes por local.'
							embedded
						>
							<ReportsByLocation refreshDefinitions={refreshDefinitions}/>
						</ModuleAccessGate>
					</Tabs.TabPane>
				</Tabs>
			</Card>						
			{scheduledReportsDrawer && <ReportDefinitionsDrawer onFinish={(changes: boolean) => {setScheduledReportsDrawer(false); changes && setRefreshDefinitions(!refreshDefinitions)}} />}
		</>
    )
}
